import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface SharedError {
  message: string;
  status?: number;
  errorType: 'HTTP' | 'Application';
  redirectUrl?: string;
  details?: string[];
}


@Injectable({
  providedIn: 'root'
})
export class ErrorEventService {
  private errorEventSource = new Subject<SharedError>();
  errorEvent$: Observable<SharedError> = this.errorEventSource.asObservable();

  emitErrorEvent(error: SharedError): void {
    this.errorEventSource.next(error);
  }
}
